<template>
    <div>
        <div>
            <h4 class="instruction-important">
                {{ $t('enjoy the game') | capitalize }}
            </h4>
            <div class="instruction">
                {{ $t('Thank you for trusting us. Your account has been successfully verified.') }}
            </div>
        </div>
        <div class="important-box">
            <div class="important-box__left">
                <i class="icon icon--md icon-help_circle"/>
                <div>{{ $t('status') | capitalize }}</div>
            </div>
            <div class="important-box__right green">
                {{ $t('verified') | capitalize }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ApprovedStatus',
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/userProfile/idCardVerification/components/ApprovedStatus.vue